import dynamic, { DynamicOptions } from 'next/dynamic'

export const CheckoutLegalTermsExperiment = dynamic(
  import('./CheckoutLegalTermsExpComponent')
    .then((mod) => mod.CheckoutLegalTermsExpComponent)
    .catch((err) =>
      // eslint-disable-next-line no-console
      console.error(`Failed to load the CheckoutLegalTermsExpComponent!`, err),
    ) as DynamicOptions<Record<string, never>>,
  { ssr: false },
)
